/* Modulo: Image Accordion
 *
 * The open panel is carried by the `.is-open` CLASS, set here. There is
 * deliberately no CSS `:hover` rule driving the mechanic: iOS Safari applies
 * `:hover` on tap and makes it STICK, which is the `product-lineup` bug class.
 * Keeping the state in JS makes that unreachable rather than merely guarded.
 *
 * `window.moduloLazyInit` is deliberately NOT used — it does not exist in this
 * repo (0 definitions; modulo-core.js is not on disk) despite many files
 * carrying the dead branch. The `product-quickbuy` precedent.
 */
(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var HOVER_Q = '(hover: hover) and (pointer: fine)';
  var MOTION_Q = '(prefers-reduced-motion: reduce)';

  function mq(q) {
    return window.matchMedia ? window.matchMedia(q) : { matches: false };
  }

  function panelsOf(rail) {
    var out = [];
    var kids = rail.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].classList && kids[i].classList.contains('modulo-ia__panel')) out.push(kids[i]);
    }
    return out;
  }

  function initSection(root) {
    if (!root || root.hasAttribute('data-modulo-ia-ready')) return;
    root.setAttribute('data-modulo-ia-ready', '');

    var rail = root.querySelector('.modulo-ia__rail');
    if (!rail) return;

    var panels = panelsOf(rail);
    if (panels.length < 2) return;   // single panel renders static; nothing to drive

    function open(panel) {
      for (var i = 0; i < panels.length; i++) {
        var on = panels[i] === panel;
        panels[i].classList.toggle('is-open', on);
        var t = panels[i].querySelector('.modulo-ia__trigger');
        if (t) t.setAttribute('aria-expanded', on ? 'true' : 'false');
      }
    }

    // Read the hover capability LIVE rather than caching a boolean at load —
    // a 2-in-1 laptop can gain or lose a fine pointer mid-session.
    var hoverQ = mq(HOVER_Q);

    for (var i = 0; i < panels.length; i++) {
      (function (panel) {
        var btn = panel.querySelector('.modulo-ia__trigger');
        if (!btn) return;

        btn.addEventListener('click', function () { open(panel); });

        // focus-visible opens too, so a keyboard user gets the same affordance
        // a mouse user does. `:focus-visible` keeps it off plain mouse focus.
        btn.addEventListener('focus', function () {
          if (btn.matches && btn.matches(':focus-visible')) open(panel);
        });

        panel.addEventListener('pointerenter', function (e) {
          if (!hoverQ.matches) return;
          if (e.pointerType && e.pointerType !== 'mouse') return;
          open(panel);
        });

        btn.addEventListener('keydown', function (e) {
          var idx = panels.indexOf ? panels.indexOf(panel) : -1;
          if (idx < 0) { for (var k = 0; k < panels.length; k++) if (panels[k] === panel) idx = k; }
          var next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = panels[idx + 1];
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = panels[idx - 1];
          else if (e.key === 'Home') next = panels[0];
          else if (e.key === 'End') next = panels[panels.length - 1];
          if (!next) return;
          e.preventDefault();
          var nb = next.querySelector('.modulo-ia__trigger');
          if (nb) nb.focus();
        });
      })(panels[i]);
    }

    // Nothing here animates on a timer, so reduced motion only needs the CSS
    // side. Kept as a live query so a mid-session toggle is honoured if the
    // behaviour ever grows a timed component.
    mq(MOTION_Q);
  }

  function boot(scope) {
    var els = (scope || document).querySelectorAll('[data-modulo-ia]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  // An identical <script src> still executes once per tag, so document-level
  // wiring is guarded (the `announcement-statement` / `header-pill` lesson).
  if (!window.moduloIaWired) {
    window.moduloIaWired = true;
    document.addEventListener('shopify:section:load', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.matches && t.matches('[data-modulo-ia]')) initSection(t);
      else boot(t);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
})();
